//hijack a tag clicks within pagination
jQuery(function($){
    // TODO: add ajax
    // $('.pagination-container a').click(function (e) {
    //     e.preventDefault();
    //     let href = ($(this).attr('href'));
    //
    //     hrefBits =
    //
    //     $.ajax({
    //         type: 'post',
    //         url: local_vars.ajaxurl,
    //         data: { action: 'get_news', href },
    //         dataType: 'html',
    //         success: function(res){
    //             console.log(res)
    //         },
    //         error: function( jqXHR, textStatus, errorThrown ){
    //             console.log('there was an error');
    //             console.log(textStatus);
    //             console.log(errorThrown);
    //         },
    //     });
    //
    // });
});